/* ++++++++++ --------------- COMPANY PAGE : STYLES --------------- ++++++++++ */
export default {
  company: {

  }
};